module.exports = __webpack_public_path__ + "img/logo_bistrobus.0c2c358e.png";